import type { FavoriteEntry, ViewEventResult } from '@/types/api'
import { request, requestData } from './client'

/**
 * 阅读登记与收藏。openapi.yaml tags: engage。
 *
 *   - 阅读事件按 (post, 匿名 ID, **UTC 日**) 去重，日期由服务端生成。
 *     它是 POST，所以照样要 CSRF —— client.ts 已统一处理。
 *   - 收藏是幂等的 PUT / DELETE，**首期不支持匿名收藏**（未登录 401）。
 *   - 收藏列表按 `favorited_at` 用 `before` 向前翻页，不用 cursor。
 */

export function recordView(slug: string, signal?: AbortSignal): Promise<ViewEventResult> {
  return requestData<ViewEventResult>(`/posts/${encodeURIComponent(slug)}/view-events`, {
    method: 'POST',
    ...(signal ? { signal } : {}),
  })
}

export async function addFavorite(slug: string, signal?: AbortSignal): Promise<void> {
  await request<void>(`/posts/${encodeURIComponent(slug)}/favorite`, {
    method: 'PUT',
    ...(signal ? { signal } : {}),
  })
}

export async function removeFavorite(slug: string, signal?: AbortSignal): Promise<void> {
  await request<void>(`/posts/${encodeURIComponent(slug)}/favorite`, {
    method: 'DELETE',
    ...(signal ? { signal } : {}),
  })
}

export async function fetchFavorites(
  params: { limit?: number; before?: string } = {},
  signal?: AbortSignal,
): Promise<FavoriteEntry[]> {
  const data = await requestData<{ items: FavoriteEntry[] }>('/me/favorites', {
    query: {
      ...(params.limit !== undefined ? { limit: params.limit } : {}),
      ...(params.before ? { before: params.before } : {}),
    },
    ...(signal ? { signal } : {}),
  })
  return data.items
}
